export const CHANGE_DECLARACAO_PF_VALUE_FORM = "CHANGE_DECLARACAO_PF_VALUE_FORM";
export const CHANGE_DECLARACAO_PJ_VALUE_FORM = "CHANGE_DECLARACAO_PJ_VALUE_FORM";
export const HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG = "HANDLE_CHANGE_DECLARACAO_SOU_PESSOA_FLAG";
export const HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG = "HANDLE_CHANGE_DECLARACAO_RELACIONAMENTO_FLAG";
export const HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG = "HANDLE_CHANGE_DECLARACAO_SOCIO_FLAG";
export const HANDLE_CHANGE_DECLARACAO_FATCA_FLAG = "HANDLE_CHANGE_DECLARACAO_FATCA_FLAG";
export const HANDLE_CHANGE_DECLARACAO_PERSON_FLAG = "HANDLE_CHANGE_DECLARACAO_PERSON_FLAG";
export const HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO = "HANDLE_CHANGE_DECLARACAO_OPERACAO_IMPORTACAO";
export const HANDLE_CHANGE_PESSOA_AMERICANA = "HANDLE_CHANGE_PESSOA_AMERICANA";
export const CHANGE_DECLARACAO_NIF = "CHANGE_DECLARACAO_NIF";
export const HANDLE_CHANGE_DADOS_NIF_COUNTRY = "HANDLE_CHANGE_DADOS_NIF_COUNTRY";
export const HANDLE_CHANGE_DADOS_RENDA_MENSAL = "HANDLE_CHANGE_DADOS_RENDA_MENSAL";
export const HANDLE_CHANGE_DADOS_PATRIMONIO = "HANDLE_CHANGE_DADOS_PATRIMONIO";
export const FILL_PROFESSION_LIST = "FILL_PROFESSION_LIST";
export const SET_LISTA_DECLARACAO_ANUAL = "SET_LISTA_DECLARACAO_ANUAL";
export const HANDLE_CHANGE_DECLARACAO_ANUAL = "HANDLE_CHANGE_DECLARACAO_ANUAL";
